define('view/controller/gdpr-report/GdprReportMainView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     *
     *
     * @class GdprReportMainView
     */
    return LayoutView.extend({

        template: '#gdpr_report_main_view',

        ui: {
            'confirmationBtn': '#sb_gdpr_report_show_confirmation'
        },

        events: {
            'click @ui.confirmationBtn': '_onClickConfirmationBtn'
        },

        modelEvents: {
            'change': 'render'
        },

        imageKeys : ['picture_path', 'image'],
        urlKeysPart : ['_path', 'url', 'domain', 'link'],

        initialize: function (options) {

        },

        onRender: function () {
            if (this.model.get('id') && !this.model.get('code_confirmed')) {
                // notify controller to ask for confirmation code
                this.triggerMethod('confirmation_required');
            }
        },

        _onClickConfirmationBtn: function () {
            this.triggerMethod('confirmation_required');
            return false;
        },

        convFunc : function (str) {
            if(str && _.isString(str)) {
                 str = str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
            }
            return str;
        },

        escapeHtml : function(str) {
            //console.log(str);
            var inst = this;
            var allowedTags = ['&emsp;', '&nbsp;', '<br>', '<b>', '</b>','<p>', '</p>', '<strong>', '</strong>'];

            if(str) {
                str = this.convFunc(str);
                jQuery.each(allowedTags, function(n, tag){
                    var convTag = inst.convFunc(tag);
                    var reg = new RegExp(convTag,"g");
                    //console.log(str);
                    if(str && _.isString(str)) {
                        str = str.replace(reg, tag);
                    }
                });
                return str;
            }
            return '-';
        },

        serializeData: function () {
            var inst = this;
            var result = $.extend(true, {}, Marionette.ItemView.prototype.serializeData.apply(this));
            var newResult = {};

            _.each(result, function(value, key){
                //if(value && _.isArray(value)) {
                newResult[key] = value;
                //}
                if(value && !_.isArray(value) && _.isObject(value)) {
                    newResult[key] = [value];
                }

                if(_.isArray(newResult[key])) {
                    _.each(newResult[key], function (row, num) {
                        _.each(row, function (itemValue, itemKey) {

                            if(itemValue) {
                                newResult[key][num][itemKey] = itemValue = inst.escapeHtml(itemValue);
                            }

                            if(!_.isEmpty(itemValue) && inst.imageKeys.indexOf(itemKey) >= 0){
                                newResult[key][num][itemKey] = '<img src="'+itemValue+'" alt="" /><br><small>'+itemValue+'</small>';
                            } else
                            if(!_.isEmpty(itemValue) && itemKey.indexOf("email") >= 0){
                                newResult[key][num][itemKey] = '<a href="mailto:'+itemValue+'">'+itemValue+'</a>';
                            } else {
                                var isUrl = false;
                                _.each(inst.urlKeysPart, function (urlKeyPath) {
                                    if(!_.isEmpty(itemValue) && itemKey.indexOf(urlKeyPath) >= 0){
                                        isUrl = true;
                                    }
                                });

                                if(isUrl){
                                    newResult[key][num][itemKey] = '<a href="'+itemValue+'">'+itemValue+'</a>';
                                }
                            }
                        });
                    });
                }

            });

            return newResult;
        },

        onPrintReport : function () {
            jQuery('body').addClass('report-page');
            window.print();
        },

        onJsonReport : function () {
            window.location.href = "/v2/gdpr-report/json";
        }

    });

});

